<svg-icon [ngClass]="classes" src="/assets/icons/{{ svgName }}.svg" [svgStyle]="svgStyles"></svg-icon>